export default __webpack_public_path__ + "static/media/logo-icon.df18da71.svg";